import { Component, EventEmitter, Output } from '@angular/core';
import { CommonService } from '../../../../shared/services/common.service';
import { ApiService } from '../../../../shared/services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  @Output() menuToggle = new EventEmitter<void>();
  userType = sessionStorage.getItem('UserType');
  name = sessionStorage.getItem('name');

  msMeUserName = sessionStorage.getItem('msMeUserName');
  isProfileCompleted = sessionStorage.getItem('isProfileCompleted') === 'true' ? true : false;
  constructor(private router: Router, private apiService: ApiService, public commonService: CommonService) { }


  isMSMEUser: boolean = false;
  isIAUser: boolean = false;
  isMSSIDCUser: boolean = false;
  isDICUser: boolean = false;


  CheckUserType() {
    if (this.userType === 'MSSIDC') {
      this.isMSSIDCUser = true;
    }
    else if (this.userType === 'MSME') {
      this.isMSMEUser = true;
    }
    else if (this.userType === 'IA') {
      this.isIAUser = true;
    }
    else if (this.userType === 'DIC') {
      this.isDICUser = true;
    }
    else {
      this.isMSMEUser = false;
      this.isIAUser = false;
      this.isMSSIDCUser = false;
      this.isDICUser = false;
    }
  }

  isMasterSubMenuVisible: boolean = false;
  isReportSubMenuVisible: boolean = false;
  isMyProfileSubMenuVisible: boolean = false;
  isUserManualSubMenuVisible: boolean = false;

  // Function to toggle the visibility of the submenu
  toggleMasterSubMenu() {
    this.isMasterSubMenuVisible = !this.isMasterSubMenuVisible;
    this.isReportSubMenuVisible = false;
  }
  toggleReportSubMenu() {
    this.isReportSubMenuVisible = !this.isReportSubMenuVisible;
    this.isMasterSubMenuVisible = false;
  }

  toggleMSMEProfileSubMenu() {
    this.isMyProfileSubMenuVisible = !this.isMyProfileSubMenuVisible;
  }

  toggleUserManualSubMenu() {
    this.isUserManualSubMenuVisible = !this.isUserManualSubMenuVisible;
    //this.isUserManualSubMenuVisible = false;
  }


  openIAUserManual() {
    var filePath = 'Images\\UserManual\\IA\\RAMP-Portal-UserManul-For-V1-IA.pdf';
    var fileName = 'RAMP-Portal-UserManul-For-V1-IA.pdf';
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }

  openMSMEUserManual() {
    var filePath = 'Images\\UserManual\\MSME\\RAMP-Portal-UserManul-For-V1-MSME.pdf';
    var fileName = 'RAMP-Portal-UserManul-For-V1-MSME.pdf';
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }
  get normalizedUserType(): string {
    return (this.userType || '').trim().toLowerCase();
  }
}

